import { render, staticRenderFns } from "./ItemViewer.vue?vue&type=template&id=a9a5b6c4&scoped=true"
import script from "./ItemViewer.vue?vue&type=script&lang=js"
export * from "./ItemViewer.vue?vue&type=script&lang=js"
import style0 from "./ItemViewer.vue?vue&type=style&index=0&id=a9a5b6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a5b6c4",
  null
  
)

export default component.exports